import React from 'react';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { range } from '~/lib/helper/ArrayHelper';
import { asNumberOrDefault } from '~/lib/helper/StringHelper';
import ErrorList from '../ErrorList';

type IpAddressOptionProps = {
    interfaces: number;
    errors?: string[];
    discountForNone: number;
    costPerInterface: number;
    maxInterfaces: number;
    onChange: (num: number) => void;
};

export default class IpAddressOption extends React.Component<IpAddressOptionProps> {
    render() {
        const { interfaces, onChange, discountForNone, costPerInterface, errors } = this.props;
        return (
            <FormGroup>
                <Label for="ipAddressSelection">IP Addresses</Label>
                <Input
                    id="ipAddressSelection"
                    type="select"
                    name="ipAddressSelection"
                    invalid={!!errors}
                    value={interfaces}
                    onChange={(e) => onChange(asNumberOrDefault(e.target.value, 0))}
                >
                    <option value={0}>
                        No External IP {discountForNone > 0 && `(-$${discountForNone.toFixed(2)})`}
                    </option>
                    <option value={1}>1 IP address (included)</option>
                    {range(2, this.props.maxInterfaces).map((i) => (
                        <option key={i} value={i}>
                            {i} IP addresses (+${(costPerInterface * (i - 1)).toFixed(2)} per month)
                        </option>
                    ))}
                </Input>
                <FormFeedback>
                    <ErrorList errors={errors} />
                </FormFeedback>
            </FormGroup>
        );
    }
}
